import { AuthenticationEntity } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'
import {
  BaseEventTicketEntity,
  EventTicketProfilePayload,
} from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'

// re-export base event tickets models from shared lib
export * from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'

/**
 * Interface for the 'EventTickets' data
 */
export interface EventTicketEntity extends BaseEventTicketEntity {}

export interface AcceptEventTicketInvitePayload extends EventTicketProfilePayload {
  accepted_by?: string | null
}

export interface AcceptEventTicketInviteResponse {
  authentication: AuthenticationEntity | null
  event_ticket: EventTicketEntity
}
